let giftSwitchers = document.querySelectorAll('.gift__switch') || false;


const toggleGift = () => {
    let target = event.target.closest('.gift__switch');
    let giftStatus = target.dataset.type;
    let productForm = document.querySelector('#main-prodct-form .form');
    let giftInpout = productForm.querySelector('input[name="properties[_gifts]"]');

    giftSwitchers.forEach(switcher => switcher.classList.remove('active'));
    target.classList.add('active');

    if (giftStatus == 'disabled') {
      
        giftInpout.setAttribute('disabled', true);
        
    }else{
        giftInpout.hasAttribute('disabled')&& giftInpout.removeAttribute('disabled');
    }
}

giftSwitchers.length > 0 && giftSwitchers.forEach(switcher => switcher.addEventListener('click', toggleGift));